import React, { useState } from 'react';
import { FaWhatsapp, FaCheckCircle, FaCogs, FaShieldAlt, FaGasPump, FaShip, FaMapMarkerAlt } from 'react-icons/fa';

const CarDetailsCaracas = () => {
    const [mainImage, setMainImage] = useState("Frontlander1.png");
    const BUCKET_URL = "/caracas/"; 
    const images = ["Frontlander1.png", "Frontlander2.png", "Frontlander3.png", "Frontlander4.png", "Frontlander5.png"];

    const phoneNumber = "13054076280"; // Tu número real aquí
    const whatsappMessage = encodeURIComponent(
        "Hola, me interesa la Toyota Frontlander 2025 que vi en la web de Vimcarbroker."
    );
    const whatsappLink = `https://wa.me/${phoneNumber}?text=${whatsappMessage}`;

    return (
        <div style={{ backgroundColor: '#020617', minHeight: '100vh', color: 'white', padding: '40px 20px', fontFamily: "'Inter', sans-serif" }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                
                {/* 🏷️ Encabezado Principal Renovado */}
                <div style={{ borderBottom: '1px solid #1e293b', paddingBottom: '30px', marginBottom: '40px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '20px' }}>
                        <div>
                            <h1 style={{ fontSize: '4em', margin: 0, fontWeight: '900', color: '#ffffff', lineHeight: '1' }}>
                                Toyota Frontlander 2025
                            </h1>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginTop: '15px' }}>
                                <span style={{ background: '#3b82f6', color: 'white', padding: '5px 15px', borderRadius: '5px', fontWeight: 'bold' }}>DISPONIBLE EN CARACAS</span>
                                <span style={{ color: '#94a3b8', fontSize: '1.1em' }}>0 KM | Versión Gasoline High-Efficiency</span>
                            </div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <p style={{ fontSize: '3em', color: '#22c55e', fontWeight: '900', margin: 0 }}>$46,000</p>
                            <p style={{ color: '#64748b', margin: 0 }}>Entrega Inmediata</p>
                        </div>
                    </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '50px' }}>
                    
                    {/* 📸 Galería */}
                    <div>
                        <img src={`${BUCKET_URL}${mainImage}`} alt="Frontlander" style={{ width: '100%', borderRadius: '24px', boxShadow: '0 30px 60px rgba(0,0,0,0.6)', border: '1px solid #1e293b' }} />
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '12px', marginTop: '20px' }}>
                            {images.map(img => (
                                <img 
                                    key={img} 
                                    src={`${BUCKET_URL}${img}`} 
                                    onClick={() => setMainImage(img)}
                                    style={{ 
                                        width: '100%', height: '70px', objectFit: 'cover', borderRadius: '12px', cursor: 'pointer',
                                        border: mainImage === img ? '3px solid #3b82f6' : '1px solid #334155',
                                        opacity: mainImage === img ? 1 : 0.6
                                    }} 
                                />
                            ))}
                        </div>
                    </div>

                    {/* 🛠️ Info y Banner de Importación */}
                    <div>
                        {/* Banner de Importación 2026 */}
                        <div style={{ background: 'linear-gradient(90deg, #1e3a8a 0%, #3b82f6 100%)', padding: '20px', borderRadius: '20px', marginBottom: '30px', display: 'flex', alignItems: 'center', gap: '20px' }}>
                            <FaShip size={40} color="white" />
                            <div>
                                <h3 style={{ margin: 0, fontSize: '1.2em' }}>¿Buscas el modelo 2026?</h3>
                                <p style={{ margin: 0, opacity: 0.9 }}>Importamos tu vehículo bajo pedido con Vimcarbroker.</p>
                            </div>
                        </div>

                        <h2 style={{ fontSize: '1.6em', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <FaCogs color="#3b82f6" /> Especificaciones Técnicas
                        </h2>
                        
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '30px' }}>
                            <div style={{ background: '#0f172a', padding: '15px', borderRadius: '15px', border: '1px solid #1e293b' }}>
                                <p style={{ margin: 0, color: '#64748b', fontSize: '0.8em' }}>Motor</p>
                                <strong>2.0L Dynamic Force (171 HP)</strong>
                            </div>
                            <div style={{ background: '#0f172a', padding: '15px', borderRadius: '15px', border: '1px solid #1e293b' }}>
                                <p style={{ margin: 0, color: '#64748b', fontSize: '0.8em' }}>Transmisión</p>
                                <strong>Direct Shift-CVT 10 Vel.</strong>
                            </div>
                        </div>

                        {/* ✅ Equipamiento Real */}
                        <div style={{ background: 'rgba(30, 41, 59, 0.5)', padding: '25px', borderRadius: '25px', border: '1px solid #334155' }}>
                            <h3 style={{ marginTop: 0, color: '#3b82f6', fontSize: '1.1em' }}>Equipamiento Destacado</h3>
                            <ul style={{ listStyle: 'none', padding: 0, display: 'grid', gap: '10px', fontSize: '0.95em' }}>
                                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><FaCheckCircle color="#10b981" /> Pantalla Touch HD 10.25" Inalámbrica</li>
                                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><FaCheckCircle color="#10b981" /> Toyota Safety Sense (Seguridad Activa)</li>
                                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><FaCheckCircle color="#10b981" /> Faros Bi-LED con encendido automático</li>
                                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><FaCheckCircle color="#10b981" /> 7 Airbags e ISOFIX</li>
                                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><FaCheckCircle color="#10b981" /> Cámara de Reversa con guías dinámicas</li>
                            </ul>
                        </div>

                        <a href={whatsappLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                            <button style={{ 
                                width: '100%', marginTop: '30px', padding: '22px', background: '#22c55e', color: 'white', 
                                border: 'none', borderRadius: '18px', fontSize: '1.2em', fontWeight: 'bold', cursor: 'pointer',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px', transition: '0.3s'
                            }}>
                                <FaWhatsapp size={25} /> CONTACTAR A VIMCARBROKER
                            </button>
                        </a>
                        <p style={{ textAlign: 'center', color: '#64748b', marginTop: '15px', fontSize: '0.9em' }}>
                           <FaMapMarkerAlt /> Ubicación: Caracas / Venezuela.
                        </p>
                    </div>
                </div>

                {/* 📝 Ficha Técnica Única */}
                <div style={{ marginTop: '60px', background: '#0f172a', padding: '40px', borderRadius: '30px', border: '1px solid #1e293b' }}>
                    <h2 style={{ textAlign: 'center', marginBottom: '40px' }}>Ficha Técnica de Fábrica</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '40px' }}>
                        <div>
                            <h4 style={{ color: '#3b82f6', borderBottom: '1px solid #334155', paddingBottom: '10px' }}>Capacidades</h4>
                            <p><strong>Largo:</strong> 4,485 mm</p>
                            <p><strong>Maletero:</strong> 438 Litros</p>
                            <p><strong>Tanque:</strong> 47 Litros</p>
                        </div>
                        <div>
                            <h4 style={{ color: '#3b82f6', borderBottom: '1px solid #334155', paddingBottom: '10px' }}>Mecánica</h4>
                            <p><strong>Compresión:</strong> 13.0:1</p>
                            <p><strong>Tracción:</strong> Delantera (FWD)</p>
                            <p><strong>Suspensión:</strong> MacPherson / Eje de torsión</p>
                        </div>
                        <div>
                            <h4 style={{ color: '#3b82f6', borderBottom: '1px solid #334155', paddingBottom: '10px' }}>Seguridad</h4>
                            <p>Frenos de disco en las 4 ruedas</p>
                            <p>Control de Tracción (TRC)</p>
                            <p>Asistente de Frenado (BA)</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CarDetailsCaracas;